import { render } from "./RecipientSelector.vue?vue&type=template&id=35cd1944&scoped=true&ts=true"
import script from "./RecipientSelector.vue?vue&type=script&lang=ts"
export * from "./RecipientSelector.vue?vue&type=script&lang=ts"

import "./RecipientSelector.vue?vue&type=style&index=0&id=35cd1944&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35cd1944"]])

export default __exports__